import Vue from "vue";
import VueRouter from "vue-router";

// Page Components
import Home from "@/views/Home.vue";
import Registration from "@/views/Registration.vue";
import Register from "@/views/Register.vue";
import Checkout from "@/views/Checkout.vue";
import SideGames from "@/views/SideGames.vue";
import MessageCenter from "@/views/MessageCenter.vue";
import Admin from "@/views/Admin.vue";
import CallToTheHeart from "@/views/CallToTheHeart.vue";
import InvoiceSearch from "@/views/InvoiceSearch.vue";
import AuctionWinners from "@/views/AuctionWinners.vue";
import Reports from "@/views/Reports.vue";
import CallToTheHeartScoreboard from "@/views/CallToTheHeartScoreboard.vue";
import BidderLogin from "@/views/BidderLogin.vue";
import AuctionBidding from "@/views/AuctionBidding.vue";
import AuctionAdmin from "@/views/AuctionAdmin.vue";

import session from "@/global/session";

Vue.use(VueRouter);

const routes = [
	{
		path: "/",
		name: "Home",
		component: Home,
	},
	{
		path: "/register",
		name: "Registeration",
		component: Home,
	},
	{
		path: "/checkout",
		name: "Checkout",
		component: Checkout,
	},
	{
		path: "/checkout/:bidNumber",
		name: "CheckoutDetail",
		component: Checkout,
	},
	{
		path: "/register/:bidNumber",
		name: "GuestRegistration",
		component: Register,
	},
	{
		path: "/side-games",
		name: "SideGames",
		component: SideGames,
	},
	{
		path: "/side-games/:gameId",
		name: "SideGameDetail",
		component: SideGames,
	},
	{
		path: "/login",
		name: "BidderLogin",
		component: BidderLogin,
	},
	{
		path: "/auction",
		name: "Auction",
		component: AuctionBidding,
		// No auth guard: logged-out visitors can preview the auction. Bidding
		// surfaces are hidden client-side and bid-place.php enforces the token
		// server-side, so the page is safe to show without a session.
	},
	{
		path: "/admin",
		name: "Admin",
		component: Admin,
		meta: {
			requiresAdmin: true,
		},
	},
	{
		path: "/admin/invoice-search",
		name: "InvoiceSearch",
		component: InvoiceSearch,
		meta: {
			isAdminPage: true,
		},
	},
	{
		path: "/admin/registration",
		name: "AdminRegistration",
		component: Registration,
		meta: {
			isAdminPage: true,
		},
	},
	{
		path: "/admin/call-to-the-heart",
		name: "AdminCallToTheHeart",
		component: CallToTheHeart,
		meta: {
			isAdminPage: true,
		},
	},
	{
		path: "/admin/call-to-the-heart/scoreboard",
		name: "CallToTheHeartScoreboard",
		component: CallToTheHeartScoreboard,
	},
	{
		path: "/admin/message-center",
		name: "AdminMessageCenter",
		component: MessageCenter,
		meta: {
			isAdminPage: true,
		},
	},
	{
		path: "/admin/auction-winners",
		name: "AdminAuctionWinners",
		component: AuctionWinners,
		meta: {
			isAdminPage: true,
		},
	},
	{
		path: "/admin/auction-manager",
		name: "AdminAuctionManager",
		component: AuctionAdmin,
		meta: {
			isAdminPage: true,
		},
	},
	{
		path: "/admin/reports",
		name: "AdminReports",
		component: Reports,
		meta: {
			isAdminPage: true,
		},
	},
];

const router = new VueRouter({
	mode: "history",
	base: process.env.BASE_URL,
	routes,
});

// Route guards driven by the OTP session:
//  - Admin pages (meta.requiresAdmin or meta.isAdminPage) require an
//    authenticated session whose attendee role is "Admin".
//  - Bidder pages (meta.requiresBidder) require any authenticated session.
// Unauthenticated users go to OTP login (preserving their destination);
// authenticated non-admins are sent back to the auction. The PHP endpoints
// enforce the same role server-side, so this is UX, not the security boundary.
router.beforeEach((to, from, next) => {
	const needsAdmin = to.matched.some((record) => record.meta.requiresAdmin || record.meta.isAdminPage);
	const needsBidder = to.matched.some((record) => record.meta.requiresBidder);

	if (needsAdmin) {
		// Any non-admin (unauthenticated OR a non-admin session) is sent to the
		// login page with a post-auth redirect back to where they were headed.
		if (session.isAuthenticated() && session.isAdmin()) {
			next();
		} else {
			next({ name: "BidderLogin", query: { redirect: to.fullPath, context: "admin" } });
		}
	} else if (needsBidder && !session.isAuthenticated()) {
		next({ name: "BidderLogin", query: { redirect: to.fullPath, context: "auction" } });
	} else {
		next();
	}
});

export default router;
